import { FC, useCallback } from "react";
import { TestimonialSection } from "./component/TestimonialSection";
import { EnterpriseAuthContainer } from "./component/EnterpriseAuthContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { emptyWorkSpaceNameValue, workSpaceNameSchema } from "./validation";
import useFetch from "../../hooks/useFetch";
import { EnterpriseSignupApi } from "../../API/auth";
import { toast } from "react-toastify";
import InputField from "../../components/InputField";
import Button from "../../components/Button";

export const WorkSpaceNamePage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { load, isLoading } = useFetch();

  const signupInfo = location.state;

  const handleSignUpButton = useCallback(
    async (businessName: string, resetForm: () => void) => {
      const payload = {
        ...signupInfo,
        businessName,
      };

      load(EnterpriseSignupApi(payload)).then(() => {
        toast.success("Signed up successfully");
        resetForm();
        navigate("/enterprise/verify", {
          state: { email: signupInfo?.email },
        });
      });
    },
    [load, navigate, signupInfo]
  );

  const {
    errors,
    handleChange,
    values,
    touched,
    handleSubmit,
    isValid,
    resetForm,
    dirty,
  } = useFormik({
    initialValues: emptyWorkSpaceNameValue,
    validationSchema: workSpaceNameSchema,
    onSubmit: async (): Promise<void> => {
      await handleSignUpButton(values.businessName, resetForm);
    },
  });

  const isButtonDisabled = !isValid || !dirty;

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <EnterpriseAuthContainer>
        <>
          <div className="flex flex-col gap-2">
            <p className="text-3xl font-semibold text-black font-satoshi">
              Company Name
            </p>
            <p className="text-bash font-medium text-base font-satoshi">
              Enter the name of your company
            </p>
          </div>
          <InputField
            name="businessName"
            placeholder="Company Name"
            label="Company Name"
            error={(touched?.businessName && errors?.businessName) || ""}
            value={values.businessName}
            onChange={handleChange}
          />
          <Button
            text="Next"
            type={isButtonDisabled ? "muted" : "primary"}
            disabled={isButtonDisabled || isLoading}
            className="w-full"
            isLoading={isLoading}
            onClick={() => handleSubmit()}
          />
        </>
      </EnterpriseAuthContainer>

      <TestimonialSection />
    </div>
  );
};
